import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em", textAlign: "left" }}>
              LAISSEZ MOI <span className="purple">ME PRÉSENTER </span>
            </h1>
            <p className="home-about-body">
              Je suis tombé amoureux du montage vidéo presque par hasard, et depuis, je n'ai jamais vraiment décroché. Ce qui a commencé comme une curiosité est rapidement devenu une obsession: comprendre le rythme, le cadrage, la narration, l'émotion. J'ai appris en expérimentant, en testant, en me trompant, et en recommençant jusqu'à maîtriser les outils.
              <br />
              <br />
              Je me suis formé en autodidacte sur la
              <i>
                <b className="purple"> suite Adobe, Sony Vegas Pro et After Effects. </b>
              </i>
              Mais au-delà des logiciels, j'ai surtout appris à structurer une idée, à transformer un message brut en histoire claire, impactante et mémorable. Le montage, pour moi, ce n'est pas assembler des plans. C'est créer une intention. C'est décider ce que l'on veut faire ressentir, comprendre ou retenir.
              <br />
              <br />
              J'accorde une attention particulière au rythme, à la cohérence visuelle et à la fluidité narrative. Chaque projet est une nouvelle opportunité de raconter quelque chose différemment.
              <br />
              <br />
              Aujourd'hui, je ne cherche pas seulement à produire de belles images. Je veux créer des contenus qui servent un objectif et qui captent l'attention dans un environnement qui a du sens.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
